// extracted by mini-css-extract-plugin
export default {"galleryItem":"gallery_galleryItem__XYVLS"};